import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@vendure/admin-ui/core';
import {AppFileInputComponent} from './app-file-input.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  exports: [AppFileInputComponent],
  declarations: [AppFileInputComponent],
})
export class AppFileInputModule {}
